import classNames from 'classnames';

import { RadioIndicatorProps } from './radio-indicator.type';

/** The global radio look without an input, for a choice whose control is the surrounding button: an input inside it would be a second control. */
export const RadioIndicator = ({ isChecked, className }: RadioIndicatorProps) => (
  <span
    aria-hidden
    data-checked={isChecked || undefined}
    className={classNames('radio-indicator size-5 shrink-0 border bg-origin-border', className)}
  />
);
